"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const mapFooter_1 = __importDefault(require("../../componentMappers/mapFooter"));
const mapHeader_1 = __importDefault(require("../../componentMappers/mapHeader"));
const mapLayout_1 = require("../../componentMappers/mapLayout");
const mapToBreadcrumbProps_1 = __importDefault(require("../../componentMappers/props/mapToBreadcrumbProps"));
const gatsby_theme_leshen_1 = require("@leshen/gatsby-theme-leshen");
const componentMappers_1 = require("../../componentMappers");
function Layout({ page, main, header, footer, siteMetadata, packages = {}, forms = {}, isBlog = false, }) {
    const { initMapi } = (0, gatsby_theme_leshen_1.useMapi)();
    const { siteURL } = siteMetadata;
    const { ringpool, promoCode } = page;
    /**
     * Enable Twilio Webchat
     */
    (0, gatsby_theme_leshen_1.useChat)();
    /**
     * Init mapi with page level promo and ringpool if it has it.
     */
    (0, react_1.useEffect)(() => {
        initMapi(promoCode, ringpool);
    }, [promoCode, ringpool, initMapi]);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [header || (0, mapHeader_1.default)({ header: page.header, mappers: componentMappers_1.Mappers, packages }), main || ((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.Main, { type: isBlog ? 'blog-post' : '', children: (0, mapLayout_1.mapLayout)({
                    layout: page.layout,
                    mappers: componentMappers_1.Mappers,
                    isSpanish: page.spanish ?? false,
                    packages,
                    forms,
                }) })), !page.hideBreadcrumbs && ((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.Breadcrumbs, { className: "breadcrumbs", ...(0, mapToBreadcrumbProps_1.default)({
                    pagePath: page.pagePath,
                    shortName: page.shortName,
                    customBreadcrumbs: page.customBreadcrumbs,
                    siteURL,
                }) })), footer || (0, mapFooter_1.default)({ footer: page.footer, mappers: componentMappers_1.Mappers, packages })] }));
}
exports.default = Layout;
